import { render, staticRenderFns } from "./s-form-file.vue?vue&type=template&id=13c740fc"
import script from "./s-form-file.vue?vue&type=script&lang=js"
export * from "./s-form-file.vue?vue&type=script&lang=js"
import style0 from "./s-form-file.vue?vue&type=style&index=0&id=13c740fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports